import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "circle-empty-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 3.75012C7.44321 3.75012 3.75 7.44334 3.75 12.0001C3.75 16.5569 7.44321 20.2501 12 20.2501C16.5568 20.2501 20.25 16.5569 20.25 12.0001C20.25 7.44334 16.5568 3.75012 12 3.75012ZM2.25 12.0001C2.25 6.61491 6.61479 2.25012 12 2.25012C17.3852 2.25012 21.75 6.61491 21.75 12.0001C21.75 17.3853 17.3852 21.7501 12 21.7501C6.61479 21.7501 2.25 17.3853 2.25 12.0001Z"
    }, null, -1)
  ])))
}
export default { render: render }